<template>
  <div class="language-flag-dropdown" v-click-outside="closeDropdown">
    <img
      :src="currentLocaleOption.flag"
      :alt="currentLocaleOption.englishName"
      class="flag-trigger"
      @click="open = !open"
    />
    <div v-if="open" class="flag-menu">
      <button
        v-for="loc in locales"
        :key="loc.code"
        type="button"
        class="flag-menu-item"
        :class="{ active: currentLocale === loc.code }"
        @click="selectLocale(loc.code)"
      >
        <img :src="loc.flag" :alt="loc.englishName" class="flag-menu-flag" />
        <span class="flag-menu-name">{{ loc.nativeName }}</span>
        <b-icon
          v-if="currentLocale === loc.code"
          icon="check2"
          class="ml-auto"
        />
      </button>
    </div>
  </div>
</template>

<script>
import { setLocale } from "@/i18n";

export default {
  name: "LanguageFlagDropdown",
  data() {
    return {
      open: false,
      locales: [
        {
          code: "en",
          nativeName: "English",
          englishName: "English",
          flag: require("@/assets/197484.png"),
        },
        {
          code: "fr",
          nativeName: "Français",
          englishName: "French (Canada)",
          flag: require("@/assets/197560.png"),
        },
        {
          code: "es",
          nativeName: "Español",
          englishName: "Spanish (Mexico)",
          flag: require("@/assets/10602501.png"),
        },
      ],
    };
  },
  computed: {
    currentLocale() {
      return this.$i18n.locale;
    },
    currentLocaleOption() {
      return (
        this.locales.find((l) => l.code === this.currentLocale) || this.locales[0]
      );
    },
  },
  directives: {
    "click-outside": {
      bind(el, binding) {
        el.__clickOutsideHandler__ = (event) => {
          if (!(el === event.target || el.contains(event.target))) {
            binding.value(event);
          }
        };
        document.addEventListener("click", el.__clickOutsideHandler__);
      },
      unbind(el) {
        document.removeEventListener("click", el.__clickOutsideHandler__);
      },
    },
  },
  methods: {
    closeDropdown() {
      this.open = false;
    },
    selectLocale(code) {
      setLocale(code);
      window.location.reload();
      this.open = false;
    },
  },
};
</script>

<style scoped>
.language-flag-dropdown {
  position: relative;
  display: inline-block;
}

.flag-trigger {
  width: 30px;
  height: 30px;
  border-radius: 9999px;
  object-fit: cover;
  flex-shrink: 0;
  cursor: pointer;
  border: 1px solid rgba(0, 0, 0, 0.08);
  transition: transform 0.15s ease, box-shadow 0.15s ease;
}

.flag-trigger:hover {
  transform: scale(1.05);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);
}

.flag-menu {
  position: absolute;
  top: calc(100% + 8px);
  right: 0;
  min-width: 170px;
  background: #fff;
  border: 1px solid rgba(0, 0, 0, 0.08);
  border-radius: 8px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
  padding: 6px;
  z-index: 1000;
}

.flag-menu-item {
  display: flex;
  align-items: center;
  width: 100%;
  padding: 8px 10px;
  background: transparent;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  color: #1b1d21;
  text-align: left;
  transition: background-color 0.15s ease;
}

.flag-menu-item:hover {
  background-color: #f5f7fa;
}

.flag-menu-item.active {
  color: #2d69f6;
  font-weight: 600;
}

.flag-menu-flag {
  width: 22px;
  height: 22px;
  border-radius: 9999px;
  object-fit: cover;
  margin-right: 10px;
}

.flag-menu-name {
  flex: 1;
}
</style>
